<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.usersCount.title"
                        [body]="{
                            value: kpi.usersCount,
                            precision: texts.usersCount.precision,
                        }"
                        [badge]="{
                            value: kpi.usersCountEvolution,
                            suffix: texts.usersCount.badgeSuffix,
                            precision: texts.usersCount.badgePrecision,
                            style: kpi.usersCountEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.usersCount.descriptionTitle"
                        [descriptionContent]="texts.usersCount.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'usersCount')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalConsumption.title"
                        [body]="{
                            value: kpi.totalConsumption,
                            precision: texts.totalConsumption.precision,
                            suffix: texts.totalConsumption.suffix,
                        }"
                        [badge]="{
                            value: kpi.totalConsumptionEvolution,
                            suffix: texts.totalConsumption.badgeSuffix,
                            precision: texts.totalConsumption.badgePrecision,
                            style: kpi.totalConsumptionEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.totalConsumption.descriptionTitle"
                        [descriptionContent]="texts.totalConsumption.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalConsumption')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalIncome.title"
                        [body]="{
                            value: kpi.totalIncome,
                            precision: texts.totalIncome.precision,
                            suffix: texts.totalIncome.suffix,
                        }"
                        [badge]="{
                            value: kpi.totalIncomeEvolution,
                            suffix: texts.totalIncome.badgeSuffix,
                            precision: texts.totalIncome.badgePrecision,
                            style: kpi.totalIncomeEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalIncome')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="numberLvMvUserEvolutionChart"
                [title]="texts.numberLvMvUserEvolutionChart.title"
                [error]="nbrLvMvUserChartError"
                [isLoading]="!nbrLvMvUserChartData()[0].organizationId"
                [series]="nbrLvMvUserChartSeries"
                [dataLabels]="nbrLvMvUserDataLabels"
                [stacked]="true"
                [yaxis]="nbrLvMvUserYaxis"
                [xaxisCategories]="numberLvMvUserXaxisCategories"
                [precision]="texts.numberLvMvUserEvolutionChart.precision"
                [customTooltip]="nbrLvMvUserCustomTooltip"
                [xaxisTitle]="texts.numberLvMvUserEvolutionChart.xaxisTitle"
                [legend]="nbrLvMvUserLegend"
                class="h-100">
            </chart-card>

            <chart-card
                id="consumptionUserEvolutionChart"
                [title]="texts.consumptionUserEvolutionChart.title"
                [error]="consUserChartError"
                [isLoading]="!consUserChartData()[0].organizationId"
                [series]="consUserChartSeries"
                [dataLabels]="consUserDataLabels"
                [stacked]="true"
                [yaxis]="consUserYaxis"
                [xaxisCategories]="consUserXaxisCategories"
                [customTooltip]="consUserCustomTooltip"
                [xaxisTitle]="texts.consumptionUserEvolutionChart.xaxisTitle"
                [legend]="consUserLegend"
                class="h-100">
            </chart-card>

            <chart-card
                id="meanConsumptionChart"
                [title]="texts.meanConsumptionChart.title"
                [error]="meanConsumptionChartError"
                [isLoading]="!meanConsumptionChartData()[0].organizationId"
                [series]="meanConsumptionChartSeries"
                [dataLabels]="meanConsumptionDataLabels"
                [stacked]="true"
                [yaxis]="meanConsumptionYaxis"
                [precision]="texts.meanConsumptionChart.precision"
                [xaxisTitle]="texts.meanConsumptionChart.xaxisTitle"
                [unitTooltip]="texts.meanConsumptionChart.unitTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="transportRevenuesChart"
                [title]="texts.transportRevenuesChart.title"
                [error]="transportRevenuesChartError"
                [isLoading]="!transportRevenuesChartData()[0].organizationId"
                [series]="transportRevenuesChartSeries"
                [dataLabels]="transportRevenuesDataLabels"
                [stacked]="true"
                [xaxisCategories]="transportRevenuesXaxisCategories"
                [yaxis]="transportRevenuesYaxis"
                [customTooltip]="transportRevenuesCustomTooltip"
                [xaxisTitle]="texts.transportRevenuesChart.xaxisTitle"
                [legend]="transportRevenuesLegend"
                class="h-100">
            </chart-card>

            <chart-card
                id="meanKwhPriceChart"
                [title]="texts.meanKwhPriceChart.title"
                [error]="meanKwhPriceChartError"
                [isLoading]="!meanKwhPriceChartData()[0].organizationId"
                [series]="meanKwhPriceChartSeries"
                [dataLabels]="meanKwhPriceDataLabels"
                [yaxis]="meanKwhPriceYaxis"
                [precision]="texts.meanKwhPriceChart.precision"
                [grid]="meanKwhPriceGrid"
                [xaxisTitle]="texts.meanKwhPriceChart.xaxisTitle"
                [unitTooltip]="texts.meanKwhPriceChart.unitTooltip"
                class="h-100">
            </chart-card>

            <geo-map-card
                [title]="texts.energyUsersMap.title"
                [descriptionContent]="texts.energyUsersMap.descriptionContent"
                [descriptionTitle]="texts.energyUsersMap.descriptionTitle"
                [geometries]="geometries()"
                [isLoading]="!geometries()[0].organizationId"
                [error]="!!geometries()[0].error"
                [getStyle]="getMapStyle"
                [legendConfig]="legendConfig"
                [mapId]="'energyCustomersMap'"
                [getTooltip]="getTooltip"></geo-map-card>
        </div>
    </div>
</div>
